module.exports = __webpack_public_path__ + "img/toy.a26a2c8b.svg";